/*
 * @description  : 
 * @Author       : Junfeng Fu
 * @Date         : 2022-12-16 11:09:28
 * @LastEditors  : Junfeng Fu
 * @LastEditTime : 2022-12-16 11:09:28
 */
/*
 * @description  : 解析时间
 * @Author       : Junfeng Fu
 * @Date         : 2022-11-01 15:02:04
 * @LastEditors  : Junfeng Fu
 * @LastEditTime : 2022-11-08 10:59:37
 */
const parseTime = (msecond,isMis=true) => {
    let step=isMis?1000:1;
    const time=parseInt((msecond||'0').toString());
    const hour=Math.floor(time/(3600*step));
    const minite=Math.floor((time%(3600*step))/(60*step));
    const second=Math.floor((time%(60*step))/step);
    const arr=[fixed(hour),fixed(minite),fixed(second)]
    return arr.join(':')
}
const fixed=(num)=>{
    if(num<10){
        return '0'+num;
    }
    return num.toString()
}

export default parseTime



// WEBPACK FOOTER //
// ./src/utils/parseTime.js